import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  AcademicCapIcon,
  LightBulbIcon,
  ClipboardDocumentCheckIcon,
  ServerStackIcon,
  UserGroupIcon,
  GlobeAltIcon,
  ChartBarIcon,
  ShieldCheckIcon,
  CogIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import {
  ClipboardDocumentListIcon,
  CircleStackIcon,
  ServerIcon,
} from "@heroicons/react/24/outline";
import { theme } from "antd";
const StrengthsWeaknesses = () => {
      const themeMode = useSelector((state) => state.themeMode);
      const chartRef = useRef(null);
      const topMenuTabs = useSelector((state) => state.topMenuTabs);
      const leftMenuVisibility = topMenuTabs.tabs.find(
        (tab) => tab.id === topMenuTabs.activeTab
      ).states.leftMenuVisibility;
      const currentSurveyInsightData = useMemo(() => {
        const activeTab = topMenuTabs.tabs.find(
          (tab) => tab.id === topMenuTabs.activeTab
        );
        return activeTab ? activeTab.states.currentSurveyInsightData : null;
      }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
      const [strengths, setStrengths] = useState([]);
      const [weaknesses, setWeaknesses] = useState([]);
      console.log("download reports", currentSurveyInsightData);
      useEffect(() => {
        console.log("strengths", currentSurveyInsightData?.reportdetail?.strengths);
        if (currentSurveyInsightData?.report_detail?.strengths) {
          setStrengths([...currentSurveyInsightData.report_detail.strengths]); // Spread kullanarak yeni array oluştur
        } else {
          setStrengths([]);
        }
        console.log(
          "weaknesses",
          currentSurveyInsightData?.reportdetail?.weaknesses
        );
        if (currentSurveyInsightData?.report_detail?.weaknesses) {
          setWeaknesses([...currentSurveyInsightData.report_detail.weaknesses]); // Spread kullanarak yeni array oluştur
        } else {
          setWeaknesses([]);
        }
      }, [currentSurveyInsightData]);
    return(
      <div>
        {currentSurveyInsightData?.report_detail?.scores !== undefined && (
            <div className="flex w-full min-h-screen flex-col">
              <div className="flex-1 flex flex-col xl:flex-row space-x-4 w-full justify-start ml-4 sm:ml-13">
                <div className="w-full xl:w-2/5 flex-col ">
                  <h1
                    className={`mt-4 flex text-[18px] sm:text-[24px] space-x-2  ${
                      themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
                    } `}
                  >
                   STRENGTHS
                  </h1>
                  <ul
                    className={` text-[14px] sm:text-[18px]  divide-y ${
                      themeMode === "dark" ? "text-white" : "text-black"
                    }`}
                  >
                    {strengths === undefined ? (
                      <li
                        className={`  text-[12px] sm:text-[18px]  ${
                          themeMode === "dark" ? "text-white" : "text-black"
                        }`}
                      >
                        Güçlü yönler yükleniyor...
                      </li> // Veri henüz gelmediyse yükleniyor yazdır
                    ) : strengths.length > 0 ? (
                      strengths.map((strength, index) => (
                        <li className="flex py-8 h-[100px]" key={index}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="green"
                            className="size-6 mr-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
                            />
                          </svg>
                          {strength}
                        </li>
                      ))
                    ) : (
                      <li>Güçlü yön bulunamadı.</li> // Veri geldi ama içinde güç bulunamadıysa
                    )}
                  </ul>
                </div>
                <div className="w-full xl:w-2/5 flex-col ">
                  <h1
                    className={`mt-4 flex text-[18px] sm:text-[24px] ${
                      themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
                    } `}
                  >
                   WEAKNESSES
                  </h1>
                  <ul
                    className={`  text-[14px] sm:text-[18px] divide-y ${
                      themeMode === "dark" ? "text-white" : "text-black"
                    }`}
                  >
                    {weaknesses === undefined ? (
                      <li
                        className={`  text-[12px] sm:text-[18px]  ${
                          themeMode === "dark" ? "text-white" : "text-black"
                        }`}
                      >
                        Zayıf yönler yükleniyor...
                      </li> // Veri henüz gelmediyse yükleniyor yazdır
                    ) : weaknesses.length > 0 ? (
                      weaknesses.map((weakness, index) => (
                        <li key={index} className="flex py-8  h-[100px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="red"
                            className="size-6 mr-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
                            />
                          </svg>
    
                          {weakness}
                        </li>
                      ))
                    ) : (
                      <li>Zayıf yön bulunamadı.</li> // Veri geldi ama içinde güç bulunamadıysa
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}
      </div>
    );
}
export default StrengthsWeaknesses